"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ExtendedDialog = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Dialog = require("@fluentui/react/lib/Dialog");

var React = _interopRequireWildcard(require("react"));

var _ExtendedDialog = require("./ExtendedDialog.classNames");

var _ExtendedDialog2 = require("./ExtendedDialog.types");

/**
 * Represents an dialog with extended capabilities like different sizing types
 */
var ExtendedDialog = /*#__PURE__*/function (_BaseComponent) {
  (0, _inherits2.default)(ExtendedDialog, _BaseComponent);

  var _super = (0, _createSuper2.default)(ExtendedDialog);

  function ExtendedDialog() {
    (0, _classCallCheck2.default)(this, ExtendedDialog);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ExtendedDialog, [{
    key: "render",
    value: function render() {
      var _this$props$size;

      var classNames = (0, _ExtendedDialog.getClassNames)((_this$props$size = this.props.size) !== null && _this$props$size !== void 0 ? _this$props$size : _ExtendedDialog2.DialogSize.small);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.Dialog, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.props), {}, {
        modalProps: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.props.modalProps), {}, {
          className: (0, _react.css)(classNames.root, this.props.className, this.props.modalProps && this.props.modalProps.className)
        })
      }));
    }
  }]);
  return ExtendedDialog;
}(_react.BaseComponent);

exports.ExtendedDialog = ExtendedDialog;